export default __webpack_public_path__ + "assets/webgl/env.f13528e7.png";